var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeadTracker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "23px",
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-head-tracker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-1046.000000, -271.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-head-tracker",
    transform: "translate(1046.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3.5 0.5 0.5 0.5 0.5 3.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0.5 10.5 0.5 13.5 3.5 13.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "17.5 13.5 20.5 13.5 20.5 10.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "20.5 3.5 20.5 0.5 17.5 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,12.5 L10.5,12.5 C7.739,12.5 5.5,10.261 5.5,7.5 L5.5,6.5 C5.5,3.739 7.739,1.5 10.5,1.5 L10.5,1.5 C13.261,1.5 15.5,3.739 15.5,6.5 L15.5,7.5 C15.5,10.261 13.261,12.5 10.5,12.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,21.305 C20.5,19.5 19.295,17.926 17.555,17.445 C15.816,16.964 13.39,16.5 10.5,16.5 C7.61,16.5 5.184,16.964 3.445,17.445 C1.705,17.927 0.5,19.5 0.5,21.305 L0.5,22.5 L20.5,22.5 L20.5,21.305 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadTracker);
export default __webpack_public_path__ + "static/media/icon-head-tracker.d2e221eaad36004a1e9eae5865a8f91e.svg";
export { ForwardRef as ReactComponent };